/**
 * Labstep
 *
 * @module components/Entity/QRCode
 * @desc QRCode for entity with a perma link
 */

import { QRCode } from 'labstep-web/core/QRCode';
import type React from 'react';
import type { EntityQRCodeProps } from './types';

export const EntityQRCode: React.FC<EntityQRCodeProps> = ({
  entity,
}) => (
  <QRCode
    name={entity.name || undefined}
    value={entity.permaLinkUrl}
  />
);
